import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "@/pages/home/components/Hero";
import AsSeenOn from "@/pages/home/components/AsSeenOn";
import EmpowerSection from "@/pages/home/components/EmpowerSection";
import AboutSection from "@/pages/home/components/AboutSection";
import ServicesSection from "@/pages/home/components/ServicesSection";
import DifferentSection from "@/pages/home/components/DifferentSection";
import InsuranceSection from "@/pages/home/components/InsuranceSection";
import CashPlanSection from "@/pages/home/components/CashPlanSection";
import AwardsSection from "@/pages/home/components/AwardsSection";
import ResultsSection from "@/pages/home/components/ResultsSection";
import MapSection from "@/pages/home/components/MapSection";
import LocationsSection from "@/pages/home/components/LocationsSection";
import ProvidersSection from "@/pages/home/components/ProvidersSection";
import ReviewsSection from "@/pages/home/components/ReviewsSection";
import ResourcesSection from "@/pages/home/components/ResourcesSection";
import OffersSection from "@/pages/home/components/OffersSection";
import FaqSection from "@/pages/home/components/FaqSection";
import ContactSection from "@/pages/home/components/ContactSection";

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <AsSeenOn />
        <EmpowerSection />
        <AboutSection />
        <ServicesSection />
        <DifferentSection />
        <InsuranceSection />
        <CashPlanSection />
        <AwardsSection />
        <ResultsSection />
        <MapSection />
        <LocationsSection />
        <ProvidersSection />
        <ReviewsSection />
        <ResourcesSection />
        <OffersSection />
        <FaqSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}